import { c as _c } from "react/compiler-runtime";
import type { CSSProperties } from "react";
import type { SizeChipLabel } from "@/lib/product-size";
import { cn } from "@/lib/utils";

// Плитка размера (Figma «Size», Айталы 21.10, photo_114/117): 50 в высоту, не
// уже 50, r10; сверху размер 15/20 w700, под ним серая подпись 13/18 w500
// (международный размер или диапазон единого размера). Выбранная — тёмная
// «бабочка» с вогнутыми боками; закончившаяся — без заливки, тонкая обводка,
// бледный текст.
//
// «Бабочка» раньше была clip-path, рассчитанным на квадрат 50×50, и широкая
// плитка («One size») при выборе оставалась прямоугольной. Теперь форма
// собрана фоном: левый и правый края — куски того же контура 7px шириной,
// между ними сплошная заливка, поэтому бока не растягиваются на любой ширине.
const SHAPE = "M0.956 3.814C0.471 1.877 1.935 0 3.932 0H45.745C47.93 0 49.555 2.021 49.085 4.155L48.455 7.011C45.601 19.97 45.808 33.416 49.06 46.282C49.537 48.168 48.111 50 46.165 50H3.661C1.82 50 0.486 48.246 0.977 46.472C4.65 33.214 4.821 19.23 1.476 5.886Z";
const CAP = 7;
const SELECTED_FILL = "#1F1F1F";
const capUrl = (x: number) => `url("data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="${x} 0 ${CAP} 50" width="${CAP}" height="50" preserveAspectRatio="none"><path d="${SHAPE}" fill="${SELECTED_FILL}"/></svg>`)}")`;

/** Фон выбранной плитки: края-«бабочка» и заливка между ними (перекрытие 0,5px — без шва). */
export const BUTTERFLY_STYLE: CSSProperties = {
  backgroundImage: `${capUrl(0)}, ${capUrl(50 - CAP)}, linear-gradient(${SELECTED_FILL}, ${SELECTED_FILL})`,
  backgroundPosition: "left top, right top, center",
  backgroundSize: `${CAP}px 100%, ${CAP}px 100%, calc(100% - ${2 * CAP - 1}px) 100%`,
  backgroundRepeat: "no-repeat"
};
export function SizeChip(t0) {
  const $ = _c(23);
  const {
    label,
    selected,
    disabled: t1,
    locked: t2,
    tone: t3,
    onSelect,
    className,
    testId
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const locked = t2 === undefined ? false : t2;
  const tone = t3 === undefined ? "gray" : t3;
  const on = selected || locked;
  const t4 = locked || undefined;
  const t5 = locked ? undefined : onSelect;
  const t6 = locked || undefined;
  const t7 = on && !disabled ? BUTTERFLY_STYLE : undefined;
  let t8;
  if ($[0] !== className || $[1] !== disabled || $[2] !== locked || $[3] !== on || $[4] !== tone) {
    t8 = cn("flex h-[50px] min-w-[50px] flex-col items-center justify-center gap-0.5 whitespace-nowrap px-2 outline-none transition-colors focus-visible:ring-2 focus-visible:ring-ds-focus disabled:cursor-not-allowed", on && !disabled ? "text-white" : disabled ? "rounded-[10px] bg-transparent text-[#161616]/20 shadow-[inset_0_0_0_0.5px_rgba(200,200,200,0.6)]" : cn("rounded-[10px] text-[#2E2E2E] hover:bg-osmix-gray-200", tone === "white" ? "bg-white" : "bg-[#F8F8F8]"), locked && "cursor-default", className);
    $[0] = className;
    $[1] = disabled;
    $[2] = locked;
    $[3] = on;
    $[4] = tone;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== label.main) {
    t9 = <span className="text-[15px] font-bold leading-5 tracking-[-0.3px]">{label.main}</span>;
    $[6] = label.main;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== disabled || $[9] !== label.sub || $[10] !== on) {
    t10 = label.sub && <span className={cn("text-[13px] font-medium leading-[18px] tracking-[-0.26px]", on && !disabled ? "text-white" : disabled ? "text-[#BBBBBB]/50" : "text-[#BBBBBB]")}>{label.sub}</span>;
    $[8] = disabled;
    $[9] = label.sub;
    $[10] = on;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== disabled || $[13] !== on || $[14] !== t10 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7 || $[19] !== t8 || $[20] !== t9 || $[21] !== testId) {
    t11 = <button type="button" data-testid={testId} data-locked={t4} onClick={t5} disabled={disabled} aria-pressed={on} aria-disabled={t6} style={t7} className={t8}>{t9}{t10}</button>;
    $[12] = disabled;
    $[13] = on;
    $[14] = t10;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
    $[21] = testId;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}